import React, { useState, useEffect, useRef } from "react";
import { LeftArrowIcon } from "../../SideBar/icons/icon";
import "./CustomContextMenu.scss";

// Separate context menu options into arrays
const databaseContextMenuOptions = {
  database: [
    "Refresh",
    "Create Table",
    "Rename Database",
    "Drop Database",
  ],
  databases: ["Create Database", "Refresh"],
};

const tableContextMenuOptions = {
  tables: [
    "Refresh",
    "View Data",
    "Add Column",
    "Remove Column",
    "Rename Table",
    "Import",
    "Export",
    "Drop Table",
    "Truncate Table",
  ],
};

// Common no-arrow options
const noArrowOptions = [
  "Create Table",
  "Refresh",
  "Restore",
  "Backup",
  "Drop Database",
  "Rename Database",
  "Create Database",
  "View Data",
  "Add Column",
  "Import",
  "Export",
  "Drop Table",
  "Truncate Table",
  "Rename Table",
];

const CustomContextMenu = ({ x, y, onOptionClick, contextMenuType }) => {
  const options =
    databaseContextMenuOptions[contextMenuType] ||
    tableContextMenuOptions[contextMenuType] ||
    [];

  const [selectedOption, setSelectedOption] = useState(options[0] || "");
  const [hoverOption, setHoverOption] = useState(null);

  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onOptionClick(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onOptionClick]);

  const handleOptionClick = (option) => {
    onOptionClick(option);
  };

  const calculatePosition = (x, y) => {
    const menuWidth = 165;
    const menuHeight = 330;
    const maxX = window.innerWidth - menuWidth;
    const maxY = window.innerHeight - menuHeight;
    return {
      left: Math.min(x, maxX),
      top: Math.min(y, maxY),
    };
  };
  const { left, top } = calculatePosition(x, y);

  return (
    <div
      ref={menuRef}
      className="database-gui-custom-context-menu"
      style={{ top: `${top}px`, left: `${left}px` }}
    >
      <ul className="database-gui-custom-context-menu-list">
        {options.map((option) => (
          <li
            key={option}
            onClick={() => handleOptionClick(option)}
            className={`database-gui-custom-context-menu-item ${
              selectedOption === option ? "selected" : ""
            } ${hoverOption === option ? "hover" : ""}`}
            onMouseEnter={() => setHoverOption(option)}
            onMouseLeave={() => setHoverOption(null)}
          >
            <span>{option}</span>
            {!noArrowOptions.includes(option) &&
              (hoverOption === option || selectedOption === option) && (
                <LeftArrowIcon className="database-gui-custom-arrow-icon" />
              )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CustomContextMenu;
